module.exports = __webpack_public_path__ + "static/media/MPLUSRounded1c-Regular.686088cf.ttf";